import axios from 'axios'
import domains from '_static/domains.json'
import { i18nLocale } from '@/plugins/i18n'
import router from '@/router/index'
import { READ_ONLY_TOKEN_SESSION_STORAGE_KEY } from '@/constants/sessionStorage.js'
import { inLocalEnv, country, environment } from '@/helpers/global.helpers'
import CUSTOM_HEADERS from '@/constants/customHeaders.js'

const HEADERS = {
	AUTHORIZATION: 'Authorization',
}

function interceptRequest (config, store, Vue) {
  store.commit('setLoading', config.loading !== false)
  config.headers = buildCommonHeaders(Vue, config.headers)
  return config
}

function interceptResponse (response, store) {
  store.commit('setLoading', false)
  return response
}

function interceptError (error, store) {
  store.commit('setLoading', false)
	// Get request URL from error
	let errorMessage
	if (error && error.request) {
		const requestUrl = error.request.responseURL
		let serverErrorMessage = error.response && error.response.data ? error.response.data.errorMessage : error.message
		errorMessage = `Request '${requestUrl}': ${(serverErrorMessage) || null}`
	} else {
		errorMessage = error.message
	}

	console.error(errorMessage)
	// Add serverErrorMessage to error object
	error.customErrorMessage = errorMessage
	if (error.config && error.config.headers[CUSTOM_HEADERS.DEFAULT_INTERCEPT_ERROR] == true) {
		store.dispatch('showDangerAlert', errorMessage)
		throw error
	}
  return error
}

function buildCommonHeaders (Vue, headers = {}) {
  if (!headers[CUSTOM_HEADERS.REFERER_WEBAPP]) {
    headers[CUSTOM_HEADERS.REFERER_WEBAPP] = window.location.href
  }
  if (!headers[CUSTOM_HEADERS.TIMEZONE]) {
    headers[CUSTOM_HEADERS.TIMEZONE] = Intl.DateTimeFormat().resolvedOptions().timeZone
  }
  if (!headers[CUSTOM_HEADERS.LANG]) {
    headers[CUSTOM_HEADERS.LANG] = i18nLocale
  }
  const returnUrl = router.currentRoute.query.returnUrl || router.currentRoute.query.ReturnUrl
  if (!headers[CUSTOM_HEADERS.RETURN_URL] && returnUrl) {
    let encodedReturnUrl = encodeURIComponent(`${returnUrl}${router.currentRoute.hash || ''}`)
    headers[CUSTOM_HEADERS.RETURN_URL] = encodedReturnUrl
  }
  if ((Vue.prototype.$apiToken && !headers[HEADERS.AUTHORIZATION]) || sessionStorage.getItem(READ_ONLY_TOKEN_SESSION_STORAGE_KEY)) {
    headers[HEADERS.AUTHORIZATION] = `Bearer ${sessionStorage.getItem(READ_ONLY_TOKEN_SESSION_STORAGE_KEY) || Vue.prototype.$apiToken}`
  }
  return headers
}

function createApiInstance (apiName, Vue) {
  return axios.create({
    baseURL: inLocalEnv ? domains.apis[apiName].local : domains.apis[apiName][country][environment],
    headers: buildCommonHeaders(Vue),
    paramsSerializer: { indexes: null }
  })
}

function createApiGwInstance (apiName, Vue) {
  return axios.create({
    baseURL: inLocalEnv ? domains.apiGw.local : `${domains.apiGw[country][environment]}/${apiName}`,
    headers: buildCommonHeaders(Vue),
    paramsSerializer: { indexes: null }
  })
}

function processApiInstance (apiInstance, apiName, store, Vue) {
  apiInstance.interceptors.request.use((config) => interceptRequest(config, store, Vue), (error) => interceptError(error, store))
  apiInstance.interceptors.response.use((response) => interceptResponse(response, store), (error) => interceptError(error, store))
  // Vue prototype name for global access is '(apiName in domains.json)+Api', except for global API, which is 'api'
  Vue.prototype[`$${apiName}${apiName !== 'api' ? 'Api' : ''}`] = apiInstance
}

function createFromDomainsFile (Vue, store) {
  for (let apiName in domains.apis) {
    let apiInstance = createApiInstance(apiName, Vue)
    processApiInstance(apiInstance, apiName, store, Vue)
  }

  for (let apiGwName of domains.apiGw.apis) {
    let apiGwInstance = createApiGwInstance(apiGwName, Vue)
    processApiInstance(apiGwInstance, apiGwName, store, Vue)
  }
}

export default {
  install (Vue, { store }) {
    createFromDomainsFile(Vue, store)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/axiosApis.js